import Link from "next/link";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { ArrowRight } from "@/icons";

const buttonVariants = cva("text-sm md:text-base transition", {
    variants: {
        type: {
            primary:
                "bg-brand-light text-white rounded-full px-6 pt-[0.5rem] pb-[0.6rem] hover:bg-contrast",
            border: "bg-transparent border border-white text-white pt-[0.5rem] pb-[0.6rem] rounded-full px-6",
            white: "bg-white text-brand-light pt-[0.5rem] pb-[0.6rem] rounded-full px-6 hover:text-white hover:bg-contrast",
            "brand-dark":
                "bg-brand-dark text-white rounded-full px-6 pt-[0.5rem] pb-[0.6rem] hover:bg-contrast",
            black: "bg-contrast text-white pt-[0.5rem] pb-[0.6rem] rounded-full px-6 hover:text-white hover:bg-brand",
            text: "hover:text-brand",
            "text-invert": "text-white hover:opacity-70",
        },
    },
    defaultVariants: {
        type: "primary",
    },
});

const arrowVariants = cva("transition", {
    variants: {
        type: {
            primary: "text-white",
            white: "group-hover:text-white",
            black: "text-white",
            text: "text-inherit group-hover:text-brand",
            "text-invert": "text-white",
        },
    },
    defaultVariants: {
        type: "primary",
    },
});

export default function Button({ type, ...props }: any) {
    if (props.as === "link") {
        return (
            <Link
                href={props.href || "#"}
                className={cn(
                    "group inline-flex w-full md:w-auto justify-center items-center gap-x-2",
                    buttonVariants({ type }),
                    props.className
                )}
                onClick={props.onClick}
            >
                {props.children}
                <ArrowRight
                    className={cn("size-4 mr-1 group-hover:translate-x-1", arrowVariants({ type }))}
                />
            </Link>
        );
    }

    if (props.as === "button") {
        return (
            <button
                className={cn(
                    "group inline-flex items-center gap-x-2 transition",
                    buttonVariants({ type }),
                    props.className
                )}
                onClick={props.onClick}
            >
                {props.children}
                <ArrowRight
                    className={cn(
                        "size-4 mr-1 group-hover:translate-x-1 transition",
                        arrowVariants({ type })
                    )}
                />
            </button>
        );
    }
}
